// /school/book, web half (006 contracts/routes.md): lazy screen from the single school-admin
// entry, after the area guard.
import type { ComponentType } from "react";

import { lazyScreen } from "@/shell/lazyScreen";

export default lazyScreen<object>(() =>
  import("@/school-admin/screens").then((m) => ({
    default: m.SectionPlaceholder as ComponentType<object>,
  })),
);
